import EntityChallengeBulkMediaEdit from './EntityChallengeBulkMediaEdit';

export default EntityChallengeBulkMediaEdit;
